<template>
  <div class="LocalizeLinks_child container-fluid">
    <div class="row">
        <div class="col mainBar">
          <div >
            <div v-bind:toolSelection="selected">
              <div class="col topText">
                <div class="title">
                  {{tool[0].title}}
                </div>
                <div class="techUsed">
                  {{tool[0].techUsed}}
                </div>
                <div class="content">
                  {{tool[0].content}}
                </div>
              </div>
            </div>
          </div> 

          <div>
            <div class="row">
              <div class="col">
                <div class="screenshots">
                  <img :src="tool[0].image2">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="issues">
                  <b>Source Code:</b> <span style="font-style:italic"> {{tool[0].sourceCodeAvailability}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocalizeLinks_child',
  data:() =>({
    tool: [{
      title: "Localized links",
      techUsed: "Python 2.7 , PySide (gui), Pandas, Xlrd and Openpyxl (to parse excel files)",
      content: "This program automatically adds the country extension to a link. As Ubisoft has many pages in different languages/countries, I built this tool to help the integrators of our team.\n\n Ce programme ajoute automatiquement l'extension de pays à un lien. Comme ubisoft a beaucoup de pages dans différents pays, j'ai construit cet outil pour aider les intégrateurs de notre équipe.",
      sourceCodeAvailability: "Unavailable, code own by Ubisoft MTL",
      image1: require("@/assets/tools/LocalizeLinks/CountryExtensionsAdded.png"),
      image2: require("@/assets/tools/LocalizeLinks/GUI_CountryExtensions.png"),
      image3: require("@/assets/tools/LocalizeLinks/Labels_countryExtensions.png")
    }]
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Righteous&display=swap');

.LocalizeLinks_child{
  font-family: 'Roboto', sans-serif;
  max-width: 700px;
  white-space:pre-wrap;
}
.topText{
  display: block;
}
.title{
  font-family: 'Righteous', cursive;
  text-align:center;
  font-weight: 700;
  font-size: 1.5em;
  margin-bottom: 2%;
}
.techUsed{
  font-style: italic;
  font-weight: 100;
  font-size: 0.7em;
  text-align: justify;
  margin-bottom: 3%;
}
.content{
  text-align: justify;
  margin-bottom: 4%;
  text-align: justify;
  font-size: 0.9em;
}
.screenshots{
  text-align:center;
  margin-left: 20%;
  margin-right: 20%;
  padding-bottom: 3%;
  height: auto;
}

.issues{
  text-align: center;
  font-size: 0.6em;
}
img{
  width:100%;
  height: 100%;
}
</style>
